import React from "react";
import { CONTACT } from "@/i18n";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  return (
    <a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      className="fixed z-50 bottom-6 end-6 group"
      aria-label="Chat on WhatsApp"
    >
      <div className="relative">
        <span className="absolute inset-0 rounded-full bg-emerald-500/40 animate-ping" />
        <div className="relative flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full ps-4 pe-5 py-3 shadow-lg shadow-emerald-500/30 transition-transform group-hover:-translate-y-0.5">
          <MessageCircle className="h-5 w-5" />
          <span className="text-sm font-medium hidden sm:inline">WhatsApp</span>
        </div>
      </div>
    </a>
  );
}
